import * as React from 'react';
import type { Project, Revision } from '../../../types';
import Panel from '../../generic/Panel';
import Text from '../../generic/Text';
import css from './ProjectInfo.module.less';

type ProjectInfoRowProps = {
  label: string;
  testId: string;
};

/** A row in the project-info card. */
const ProjectInfoRow: React.FC<ProjectInfoRowProps> = ({ label, children, testId }) =>
  <div className={css.projectInfoRow}>
    <div className={css.projectInfoLabel}>{label}</div>
    <div data-testid={testId}>{children}</div>
  </div>;

export type ProjectInfoProps = {
  project: Project;
  revision: Revision;
};

/**
 * Renders some basic info about the given project.
 */
export const ProjectInfo: React.VFC<ProjectInfoProps> = ({ project, revision }) => {
  return (
    <div className={css.projectInfo}>
      <Panel>
        <Text.H4>Package</Text.H4>
        <ProjectInfoRow label="Locator" testId="project-locator">{revision.locator}</ProjectInfoRow>
        <ProjectInfoRow label="Title" testId="project-title">{project.title}</ProjectInfoRow>
        <ProjectInfoRow label="Homepage" testId="project-homepage">{project.url}</ProjectInfoRow>
        <ProjectInfoRow label="Revision" testId="project-revision">{revision.loc?.revision || revision.locator}</ProjectInfoRow>
      </Panel>
    </div>);
};
